import { Star } from "lucide-react";

const reviews = [
  {
    name: "Marcus T.",
    city: "Louisville, KY",
    text: "These guys moved a 4-bedroom in 6 hours and didn't break a single thing. Showed up on time, charged me less than the quote. I'll never use anyone else.",
  },
  {
    name: "Sarah & Dan",
    city: "Cincinnati, OH",
    text: "We had to relocate to Tennessee last-minute. ThemBoys squeezed us in, packed our whole kitchen, drove everything 300 miles, unloaded by dinner. Stellar.",
  },
  {
    name: "Jessica L.",
    city: "Lexington, KY",
    text: "I had three giant antique cabinets and a piano. They wrapped everything like it was theirs. Best $1,800 I've spent on a move ever.",
  },
  {
    name: "Carlos R.",
    city: "Bowling Green, KY",
    text: "Office relocation done on a Sunday so we didn't lose a workday. Came in under budget. Professional from start to finish.",
  },
];

export default function Testimonials() {
  return (
    <section className="py-24 lg:py-32 bg-[#151816] text-white" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div>
            <div className="overline text-[#5BB239]">Word On The Street</div>
            <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
              600+ five-star reviews<br />don't lie.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-[#5BB239] text-[#5BB239]" />
            ))}
            <span className="font-mono-label text-xs text-white/60">4.9 / 5.0 on Google</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-white/10">
          {reviews.map((r) => (
            <article key={r.name} className="bg-[#151816] p-8 lg:p-10" data-testid={`review-${r.name.split(" ")[0].toLowerCase()}`}>
              <div className="flex gap-1 text-[#5BB239]">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-current" />
                ))}
              </div>
              <blockquote className="mt-5 font-display text-xl leading-snug">
                "{r.text}"
              </blockquote>
              <div className="mt-6 flex items-baseline justify-between">
                <span className="font-bold">{r.name}</span>
                <span className="font-mono-label text-[10px] text-white/50">{r.city}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
